import {
  booleanComparisonModes,
  numberComparisonModes,
  showAllComparisonMode,
  textComparisonModes,
} from '../utils/comparison-mode-options'
import _ from 'lodash'
import { comparisonModes, filters } from '../constants'
import { getComparisonLabel, reconciliationLabelFor } from './shared'

export const reconciliationResultDefinition = {
  type: filters.RECONCILIATION_RESULT,
  nameKey: 'reconciliation_result',
  ledgerRequired: true,

  comparisonModes() {
    return {
      number: numberComparisonModes(),
      text: textComparisonModes(),
      checkbox: booleanComparisonModes(),
      other: showAllComparisonMode(),
    }
  },

  activeSubtitle(settings, getters) {
    const { identifier, comparisonMode, comparisonValue } = settings
    const reconciliationName = reconciliationLabelFor(settings, getters)

    const flattenComparisonModes = _.flatten(_.values(this.comparisonModes()))
    const comparisonLabel = getComparisonLabel(
      comparisonMode,
      flattenComparisonModes
    )

    if (reconciliationName === undefined) {
      return ''
    }

    return `${reconciliationName}: ${identifier} ${comparisonLabel} ${comparisonValue}`
  },

  normalizeSettings(settings) {
    if (
      [
        comparisonModes.SHOW_ALL,
        comparisonModes.TRUE,
        comparisonModes.FALSE,
      ].includes(settings.comparisonMode)
    ) {
      return {
        ...settings,
        comparisonValue: '',
      }
    }

    return settings
  },

  serializeSettings(settings) {
    return {
      comparison_mode: settings.comparisonMode,
      comparison_value: settings.comparisonValue,
      reconciliation_text_id: settings.reconciliationTextId,
      partner_reconciliation_text_id: settings.partnerReconciliationTextId,
      identifier: settings.identifier,
    }
  },

  deserializeSettings(params) {
    return {
      comparisonMode: params.comparison_mode,
      comparisonValue: params.comparison_value,
      reconciliationTextId: params.reconciliation_text_id,
      partnerReconciliationTextId: params.partner_reconciliation_text_id,
      identifier: params.identifier,
    }
  },
}
